import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"

/**
 * AdminRoute — Only allows users with accountType "Admin" to access the route.
 * All other users are redirected to their respective dashboards.
 */
function AdminRoute({ children }) {
  const { token } = useSelector((state) => state.auth)
  const { user, loading } = useSelector((state) => state.profile)

  if (token === null) {
    return <Navigate to="/login" replace />
  }

  if (loading || !user) {
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        <div className="spinner"></div>
      </div>
    )
  }

  if (user.accountType !== "Admin") {
    return <Navigate to="/" replace />
  }

  return children
}

export default AdminRoute
